import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../types/base-tool-types';

const toolName = 'execute-workflow' as const;

const argumentZod = z.object({
  workflow_id: z
    .string()
    .describe('Unique identifier of the workflow to execute.'),
  site_id: z
    .string()
    .optional()
    .describe(
      'The site to run the workflow on. Provide this when no site is already ' +
        'in context — e.g. after resolving an ambiguous site with list-sites. ' +
        'When omitted, the current site context is used. The site is always ' +
        're-authorized against your access, exactly as a pre-supplied site is.'
    ),
});

export const executeWorkflowManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Execute AI workflow',
  family: 'workflows',
  llmTool: {
    name: toolName,
    description:
      'Executes an AI workflow configured for the current site. The workflow must be active and synced to the execution engine. Returns an execution ID that can be used with get-workflow-execution-status to poll for completion and results.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AIA_WORKFLOWS_MCP,
  confirmBeforeExecuting: true,
});

export type ExecuteWorkflowArgumentType = z.infer<typeof argumentZod>;
